import React, { useRef, InputHTMLAttributes, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import { Field, FieldProps } from 'formik';
import { FaFile } from 'react-icons/fa';

export interface FormikUploadButtonProps
  extends InputHTMLAttributes<HTMLInputElement> {}

const FormikUploadButton: React.FC<FormikUploadButtonProps> = ({
  name,
  accept,
}) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = useCallback(() => {
    if (inputRef?.current) {
      inputRef.current.click();
    }
  }, [inputRef]);

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <div className={classes.container}>
          <button
            type="button"
            onClick={handleClick}
            className={classes.button}
          >
            <FaFile />
          </button>
          <input
            ref={inputRef}
            onChange={(e) =>
              // @ts-ignore
              form.setFieldValue(field.name, e.currentTarget.files[0])
            }
            className={classes.input}
            type="file"
            accept={accept}
          />
        </div>
      )}
    </Field>
  );
};

const useStyles = createUseStyles({
  container: {},
  button: {
    border: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    width: '64px',
    height: '64px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: ' #f1f1f1',
    fontSize: '27px',
    '&:focus': {
      outline: 'none',
    },
  },
  input: {
    display: 'none',
  },
});

export default FormikUploadButton;
